import { render, staticRenderFns } from "./CurrentSupply.vue?vue&type=template&id=e438182e&scoped=true"
import script from "./CurrentSupply.vue?vue&type=script&lang=ts"
export * from "./CurrentSupply.vue?vue&type=script&lang=ts"
import style0 from "./CurrentSupply.vue?vue&type=style&index=0&id=e438182e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e438182e",
  null
  
)

export default component.exports